export const setIsEdit = (type,state)=>({
    type: type,
    payload: state,
  })
  